import {
  withUser,
  UserProps,
} from "@customer-tools-web/component-authentication";
import * as React from "react";
import { LoadableComponent } from "react-loadable";
import { withRouter, RouteComponentProps } from "react-router";

import { ROUTE_URL, URL_PREFIX } from "../const";
import featureToggles from "../../../config/feature-toggles.malaysia";
import { useQuery } from "@apollo/react-hooks";
import { MYSubscriptionCapabilityQuery } from "@/__generated__/listings";
import { MY_SUBSCRIPTION_CAPABILITY_QUERY } from "../../component-plans/query";

type Props = UserProps & RouteComponentProps;

export default function (
  ComposedComponent:
    | (React.ComponentClass<any, any> & LoadableComponent)
    | (React.FC<any> & LoadableComponent)
) {
  const PermissionsGuard: React.FC<Props> = (props: Props) => {
    const isCreditBrickz: boolean = props?.location?.pathname?.includes(
      ROUTE_URL.creditBrickz
    );
    const isSubscriptionRenewal: boolean = props?.location?.pathname?.includes(
      ROUTE_URL.subscriptionRenewal
    );

    const isPaymentHistory: boolean = props?.location?.pathname?.includes(
      ROUTE_URL.paymentHistory
    );

    const canAccess: boolean =
      featureToggles.PAYMENT_GATEWAY &&
      !featureToggles.REPRICING_BLOCK_SELF_SERVE;

    const { data: subscriptionCapabilityData } =
      useQuery<MYSubscriptionCapabilityQuery>(
        MY_SUBSCRIPTION_CAPABILITY_QUERY,
        {
          skip: !isSubscriptionRenewal,
          fetchPolicy: "no-cache",
        }
      );

    React.useEffect(() => {
      const whitelistedUserEmails =
        process.env.REACT_APP_FEATURE_PAYMENT_GATEWAY_WHITELIST_USER_EMAILS?.split(
          ","
        ) || [];

      const shouldRedirectToNonExistingPage =
        (!canAccess &&
          !isPaymentHistory &&
          !whitelistedUserEmails.includes(props.user.email ?? "")) ||
        (isPaymentHistory &&
          process.env.REACT_APP_FEATURE_PAYMENT_GATEWAY !== "on");

      if (shouldRedirectToNonExistingPage) {
        props.history?.push(`${URL_PREFIX}/non-existingpage`);
      }
    }, []);

    React.useEffect(() => {
      if (
        isCreditBrickz &&
        !props.user?.permissions?.selfServe?.canAccessCreditBrickz
      ) {
        props.history?.push(`${URL_PREFIX}/non-existingpage`);
      }
    }, [props.user?.permissions]);

    React.useEffect(() => {
      if (
        isSubscriptionRenewal &&
        subscriptionCapabilityData &&
        !subscriptionCapabilityData.subscriptionCapability?.isPackageRenewable
      ) {
        props.history?.push(`${URL_PREFIX}/non-existingpage`);
      }
    }, [subscriptionCapabilityData]);

    return <ComposedComponent {...props} />;
  };

  return withUser(withRouter(PermissionsGuard));
}
